import React from 'react';
import cx from 'classnames';
import { Button } from '@material-ui/core';

import chrome from 'src/assets/img/chrome.png';
import { INFINITY_EXTENSION_STORE_URL } from 'src/data/infinity';
import { useStyles } from './useStyles';

export const ButtonExtension = ({ className, onClick }) => {
  const styles = useStyles();

  return (
    <Button
      className={cx(styles.root, className)}
      onClick={onClick}
      href={INFINITY_EXTENSION_STORE_URL}
      target="_blank"
      component="a"
      variant="outlined"
    >
      <div className={styles.content}>
        <img
          className={styles.img}
          src={chrome}
          alt=""
        />
        <div className={styles.row}>
          <span className={styles.title}>
            Anyword Boost <span>(Beta)</span>
          </span>
          <span className={styles.description}>Chrome Extension</span>
        </div>
      </div>
    </Button>
  );
};
